import React from 'react';
import PlaceholderTool from '../../../components/shared/PlaceholderTool/PlaceholderTool';

/**
 * FilesPage Component
 * 
 * Page wrapper for the Files (Dateiablage) module.
 * 
 * @component
 */
export default function FilesPage() {
    return (
        <div className="page-wrapper">
            <PlaceholderTool toolKey="files" title="Dateien" />
        </div>
    );
}
